<template>
  <div class="row">
    <div class="col-12">
      <p class="text-right">
        <router-link
          v-if="$can('create', 'users')"
          :to="{ name: 'users.create' }"
          class="btn btn-primary"
        >
          <font-awesome-icon :icon="['fal', 'plus-circle']" />
          Create
        </router-link>
      </p>

      <advanced-filter
        ref="advancedFilter"
        :date-range="true"
        :refs="$refs"
        :select-filters="selectFilters"
        @ready="setDefaultFilters"
      />

      <v-server-table
        ref="table"
        :columns="columns"
        :options="options"
        url="/users?active=true"
      ></v-server-table>
    </div>
  </div>
</template>

<script type="text/babel">
import AdvancedFilter from "../../components/common/AdvancedFilter.vue";

export default {
  components: {
    AdvancedFilter,
  },

  data() {
    return {
      selectFilters: {
        brand: {
          options: [],
        },
        role: {
          options: [
            {
              label: "Superadmin",
              value: "superadmin",
            },
            {
              label: "Admin",
              value: "admin",
            },
            {
              label: "Manager",
              value: "manager",
            },
            {
              label: "Technician",
              value: "technician",
            },
          ],
        },
        status: {
          options: [
            {
              label: "Active",
              value: "Active",
            },
            {
              label: "Shadow",
              value: "Shadow",
            },
            {
              label: "Suspended",
              value: "Suspended",
            },
            {
              label: "Inactive",
              value: "Inactive",
            },
          ],
        },
      },

      entityName: "technician",
      columns: ["name", "first_name", "last_name", "email", "role", "status"],
      options: {
        advancedFilter: true,
        sortable: ["name", "first_name", "last_name", "email", "status"],
        requestAdapter: (data) => {
          const result = data;

          if (data.orderBy && data.orderBy === "name") {
            result.orderBy = "";
            result.orderByName = 1;
          }

          return result;
        },
        templates: {
          name: (h, o) =>
            h("user-object", {
              props: {
                entityId: o.id,
                name: o.name,
              },
            }),
        },
      },
    };
  },
  created() {
    this.init();
  },

  methods: {
    async init() {
      const brands = await this.$store.dispatch("brands/getData");

      brands.forEach((brand) => {
        this.selectFilters.brand.options = this.selectFilters.brand.options.concat({
          label: brand.name,
          value: brand.id,
        });
      });
    },

    setDefaultFilters() {
      if (this.$refs.advancedFilter.selectFilterValues.status === "") {
        this.$refs.advancedFilter.selectFilterValues.status = "Active";
        this.$refs.advancedFilter.$forceUpdate();
      }
    },
  },
};
</script>
